"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSigner = void 0;
const address_1 = require("../address");
const errors_1 = require("../errors");
const userKeys_1 = require("./userKeys");
const userWallet_1 = require("./userWallet");
/**
 * ed25519 signer
 */
class UserSigner {
    constructor(secretKey) {
        this.secretKey = secretKey;
    }
    static fromWallet(keyFileObject, password, addressIndex) {
        const secretKey = userWallet_1.UserWallet.decrypt(keyFileObject, password, addressIndex);
        return new UserSigner(secretKey);
    }
    static fromPem(text, index = 0) {
        let secretKey = userKeys_1.UserSecretKey.fromPem(text, index);
        return new UserSigner(secretKey);
    }
    async sign(data) {
        try {
            const signature = this.secretKey.sign(data);
            return signature;
        }
        catch (err) {
            throw new errors_1.ErrSignerCannotSign(err);
        }
    }
    /**
     * Gets the address of the signer.
     */
    getAddress(hrp) {
        const bech32 = this.secretKey.generatePublicKey().toAddress(hrp).bech32();
        return address_1.Address.newFromBech32(bech32);
    }
}
exports.UserSigner = UserSigner;
//# sourceMappingURL=userSigner.js.map